/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */ /**
 * The entry point for the admin side wp-admin resource.
 */ import { jsx as _jsx } from "react/jsx-runtime";
import "@devowl-wp/utils/lib/antd.scss";
import { createRoot } from "react-dom/client";
import { Avatar, Card, Form, Space } from "antd";
import { listenHashPluginUpdate, listenPluginDeactivation, listenPluginUpdateLinkClick } from "./others";
import { PluginUpdateModal, Provider } from "./components";
import { ready } from "@devowl-wp/react-utils";
listenPluginDeactivation();
ready(()=>{
    // Create main component for all available features (e.g. license modal)
    const node = document.createElement("div");
    document.body.appendChild(node);
    createRoot(node).render(/*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx(PluginUpdateModal, {})
    }));
    listenPluginUpdateLinkClick();
    listenHashPluginUpdate();
});
export * from "./others";
export * from "./components";
export * from "./wp-api";
export * from "./store";
// Provide some UI elements so other plugins can use the same antd class prefix e.g. extending the update modal form
// Currently only used for Real Media Library as it does not yet use an own class prefix
export { Avatar, Card, Form, Space };
